import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBan,
  faCircleCheck,
  faCircleInfo,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';

interface IAlertState {
  icon: IconDefinition;
  alertClass: string;
  textClass: string;
}

const dangerValue = {
  icon: faBan,
  alertClass: 'alert-danger',
  textClass: 'text-danger',
};

export const alertStates: { [key: string]: IAlertState } = {
  SUCCESS: {
    icon: faCircleCheck,
    alertClass: 'alert-success',
    textClass: 'text-success',
  },
  WARNING: {
    icon: faTriangleExclamation,
    alertClass: 'alert-warning',
    textClass: 'text-warning',
  },
  INFORMATION: {
    icon: faCircleInfo,
    alertClass: 'alert-info',
    textClass: 'text-info',
  },
  CRITICAL: dangerValue,
  ERROR: dangerValue,
};
